const getUserAgent = () => {
  return navigator.userAgent;
};

export default getUserAgent;
